<template>
	<dialog-form
		:value="value"
		@input="$emit('input', $event)"
		:title="
			$localize('BulkUntrashRelations.title', { count: relationIds.length })
		"
		@commit="save"
		:commit-message="$localize('BulkUntrashRelations.commitMessage')"
		:allow-continue="false"
	>
	</dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import sendCommand from '@/services/sendCommand'
export default {
	components: { DialogForm },
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		relationIds: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		async save(callback) {
			const result = await sendCommand('BulkUntrashRelations', {
				relationIds: this.relationIds,
			})
			if (result.success) {
				this.$emit('saved')
			}
			callback({ success: result.success })
		},
	},
}
</script>
